import { SVGProps } from "react";

const OpenInNewTab = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M2 14V2H8V3.33333H3.33333V12.6667H12.6667V8H14V14H2ZM6.46667 10.4667L5.53333 9.53333L11.7333 3.33333H9.33333V2H14V6.66667H12.6667V4.26667L6.46667 10.4667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default OpenInNewTab;
